import { render, staticRenderFns } from "./StoryboardVideoGenerate.vue?vue&type=template&id=3696f8c4&scoped=true"
import script from "./StoryboardVideoGenerate.vue?vue&type=script&lang=js"
export * from "./StoryboardVideoGenerate.vue?vue&type=script&lang=js"
import style0 from "./StoryboardVideoGenerate.vue?vue&type=style&index=0&id=3696f8c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3696f8c4",
  null
  
)

export default component.exports